<div class="bg-hidden !tw-h-full" (click)="onModalClick($event)">
  <div
    class="tw-flex tw-justify-between tw-h-10 tw-p-5 tw-top-10 tw-sticky tw-z-50"
  >
    <i
      class="mdi mdi-close tw-cursor-pointer tw-text-gray-200 hover:tw-text-red-400 tw-text-5xl tw-font-medium"
      (click)="onClose()"
    ></i>

    <div class="tw-flex-center tw-mt-6">
      <button
        type="button"
        (click)="zoomIn()"
        class="active:tw-text-white"
        [matTooltip]="'common.zoomIn' | translate"
      >
        <i
          class="mdi mdi-magnify-plus-outline tw-text-5xl !tw-text-gray-200 hover:!tw-text-blue-200 tw-mx-4"
        ></i>
      </button>
      <button
        type="button"
        (click)="zoomOut()"
        class="active:tw-text-white"
        [matTooltip]="'common.zoomOut' | translate"
      >
        <i
          class="mdi mdi-magnify-minus-outline tw-text-5xl !tw-text-gray-200 hover:!tw-text-blue-200 tw-mx-4"
        ></i>
      </button>
    </div>

    <div></div>
  </div>

  <div class="tw-mx-2 sm:tw-mt-14">
    <div class="tw-flex-center">
      <div class="tw-flex tw-flex-col tw-items-center">
        <div class="object-cover tw-relative main dragscroll">
          @if (type != "svg") {
          <img
            id="map"
            class="tw-object-cover"
            [src]="imageUrl"
            [ngClass]="imageClass"
          />
          }
        </div>
      </div>
    </div>
  </div>
</div>
